// public.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class PublicGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean {
    const tokenUser = localStorage.getItem('tokenUser');
    const tokenTenant = localStorage.getItem('tokenTenant');
    const tokenLocal = localStorage.getItem('token');
    const platform = localStorage.getItem('src_app');

    // Check authentication based on platform
    if (platform === 'pharmalien') {
      // Pharmalien platform: only needs tokenUser and tokenLocal
      if (tokenUser && tokenLocal) {
        try {
          const isTokenUserValid = this.checkTokenExpiration(tokenUser);
          const isTokenLocalValid = this.checkTokenExpiration(tokenLocal);

          if (isTokenUserValid && isTokenLocalValid) {
            console.log('🔒 Pharmalien user already authenticated, redirecting to /scan-bl');
            this.router.navigate(['/scan-bl']);
            return false;
          }
        } catch (error) {
          console.error('Token validation error:', error);
        }
      }
    } else if (platform === 'windoc_direct') {
      // WinDoc Direct platform: only needs tokenLocal
      if (tokenLocal) {
        try {
          const isTokenLocalValid = this.checkTokenExpiration(tokenLocal);

          if (isTokenLocalValid) {
            console.log('🔒 Windoc Direct user already authenticated, redirecting to /scan-bl');
            this.router.navigate(['/scan-bl']);
            return false;
          }
        } catch (error) {
          console.error('Token validation error:', error);
        }
      }
    } else if (platform === 'winpluspharma') {
      // WinPlus platform: needs all three tokens
      if (tokenUser && tokenTenant && tokenLocal) {
        try {
          const isTokenUserValid = this.checkTokenExpiration(tokenUser);
          const isTokenTenantValid = this.checkTokenExpiration(tokenTenant);
          const isTokenLocalValid = this.checkTokenExpiration(tokenLocal);

          if (isTokenUserValid && isTokenTenantValid && isTokenLocalValid) {
            console.log('🔒 WinPlus user already authenticated, redirecting to /scan-bl');
            this.router.navigate(['/scan-bl']);
            return false;
          }
        } catch (error) {
          console.error('Token validation error:', error);
        }
      }
    }

    // Allow access to public route if not authenticated
    return true;
  }

  private checkTokenExpiration(token: string): boolean {
    const decodedToken: any = jwtDecode(token);
    const expiration = moment(decodedToken?.exp * 1000);
    return moment(new Date()) < expiration;
  }
}
